// extracted by mini-css-extract-plugin
module.exports = {"root":"RowWithMenu_root__15ZE6","root-menu":"RowWithMenu_root-menu__2rOPK","root-btn":"RowWithMenu_root-btn__ffGH8"};